import React from 'react';

import NavCustomizationForm from './NavCustomizationForm';

const NavCustomizationComponent: React.FC = () => <NavCustomizationForm />;

export default NavCustomizationComponent;
